import React from "react";
import "./LandingPhoneMockup.css";

const copyByLanguage = {
  nl: {
    fly: "Vlieg naar: Oxford Street Londen", saved: "Opgeslagen", brand: "Zegna",
    address: "Pieter Cornelisz. Hooftstraat 76", city: "Amsterdam",
    show: "Toon interesse", withdraw: "Intrekken", public: "Openbare gegevens",
    private: "Privégegevens", surface: "Oppervlakte", frontage: "Front:",
    available: "Te huur", asking: "Vraagprijs", rent: "€ 375.000", rentType: "Huurvorm",
    external: "Extern aanbod", location: "Locatie", documents: "Documenten",
  },
  en: {
    fly: "Fly to: Oxford Street London", saved: "Saved", brand: "Zegna",
    address: "Oxford Street 200", city: "London",
    show: "Show interest", withdraw: "Withdraw", public: "Public data",
    private: "Private data", surface: "Surface", frontage: "Frontage:",
    available: "For rent", asking: "Asking rent", rent: "£ 375,000", rentType: "Offer type",
    external: "External listing", location: "Location", documents: "Documents",
  },
  de: {
    fly: "Los: Kurfürstendamm Berlin", saved: "Gespeichert", brand: "Zegna",
    address: "Kurfürstendamm 26", city: "Berlin",
    show: "Interesse zeigen", withdraw: "Zurückziehen", public: "Öffentliche Daten",
    private: "Private Daten", surface: "Fläche", frontage: "Front:",
    available: "Zu vermieten", asking: "Mietpreis", rent: "€ 375.000", rentType: "Angebotsart",
    external: "Externes Angebot", location: "Standort", documents: "Dokumente",
  },
  fr: {
    fly: "Aller à : Avenue des Champs-Élysées", saved: "Enregistré", brand: "Zegna",
    address: "Avenue des Champs-Élysées 76", city: "Paris",
    show: "Manifester mon intérêt", withdraw: "Retirer", public: "Données publiques",
    private: "Données privées", surface: "Surface", frontage: "Façade :",
    available: "À louer", asking: "Loyer demandé", rent: "375 000 €", rentType: "Type d’offre",
    external: "Offre externe", location: "Emplacement", documents: "Documents",
  },
  es: {
    fly: "Ir a: Paseo de Gracia Barcelona", saved: "Guardado", brand: "Zegna",
    address: "Paseo de Gracia 76", city: "Barcelona",
    show: "Mostrar interés", withdraw: "Retirar", public: "Datos públicos",
    private: "Datos privados", surface: "Superficie", frontage: "Fachada:",
    available: "En alquiler", asking: "Renta solicitada", rent: "375.000 €", rentType: "Tipo de oferta",
    external: "Oferta externa", location: "Ubicación", documents: "Documentos",
  },
  it: {
    fly: "Vai a: Via Montenapoleone Milano", saved: "Salvato", brand: "Zegna",
    address: "Via Montenapoleone 26", city: "Milano",
    show: "Mostra interesse", withdraw: "Ritira", public: "Dati pubblici",
    private: "Dati privati", surface: "Superficie", frontage: "Fronte:",
    available: "In affitto", asking: "Canone richiesto", rent: "375.000 €", rentType: "Tipo di offerta",
    external: "Offerta esterna", location: "Posizione", documents: "Documenti",
  },
};

const getLanguage = (value) => {
  const language = String(value || "en").split("-")[0].toLowerCase();
  return copyByLanguage[language] ? language : "en";
};

const StatusBar = () => (
  <div className="landing-phone-status">
    <strong>14:05</strong>
    <span className="landing-phone-status-icons">
      <i className="signal" /><i className="wifi" /><i className="battery">81</i>
    </span>
  </div>
);

const MapScene = ({ mapImage, copy }) => (
  <div className="landing-phone-map" style={{ "--landing-phone-map": `url(${mapImage})` }}>
    <div className="landing-phone-logo"><b>Retailmaps</b><span>.com</span></div>
    <div className="landing-phone-search">{copy.fly}</div>
    <span className="map-label label-a">Zegna</span>
    <span className="map-label label-b">Omega</span>
    <span className="map-label label-c">Messika</span>
  </div>
);

const PropertyHeader = ({ copy }) => (
  <div className="landing-phone-property-head">
    <div>
      <strong>{copy.brand}</strong>
      <span>{copy.address}</span>
      <span>{copy.city}</span>
    </div>
    <em>{copy.saved}</em>
  </div>
);

const DataTabs = ({ copy }) => (
  <div className="landing-phone-tabs">
    <strong>{copy.public}</strong>
    <span>{copy.private}</span>
  </div>
);

const SurfaceCard = ({ copy }) => (
  <div className="landing-phone-surface">
    <div><i /> <strong>{copy.surface}</strong></div>
    <span>{copy.frontage}</span>
    <b>0</b>
  </div>
);

const RentalPanel = ({ copy }) => (
  <>
    <div className="landing-phone-broker">
      <div className="broker-mark">R</div>
      <div><strong>RTM.</strong><span>Retail Broker</span></div>
      <em>{copy.available}</em>
    </div>
    <div className="landing-phone-rent">
      <span>{copy.asking}</span><strong>{copy.rent}</strong>
      <div>
        <p><small>{copy.rentType}</small><b>{copy.external}</b></p>
        <p><small>{copy.location}</small><b>—</b></p>
        <p><small>{copy.documents}</small><b>{copy.external}</b></p>
      </div>
    </div>
  </>
);

export default function LandingPhoneMockup({ language, mapImage, variant = "interest", ariaLabel }) {
  const copy = copyByLanguage[getLanguage(language)];
  const isRental = variant === "rental";
  const isWithdrawn = variant === "withdrawn";

  return (
    <div className={`landing-phone-ui ${isRental ? "rental" : ""}`} role="img" aria-label={ariaLabel}>
      <StatusBar />
      <MapScene mapImage={mapImage} copy={copy} />
      <div className="landing-phone-sheet-handle" />
      <PropertyHeader copy={copy} />
      {isRental ? (
        <RentalPanel copy={copy} />
      ) : (
        <>
          <div className={`landing-phone-action ${isWithdrawn ? "withdrawn" : ""}`}>
            {isWithdrawn ? copy.withdraw : copy.show}
          </div>
          <DataTabs copy={copy} />
          <SurfaceCard copy={copy} />
        </>
      )}
    </div>
  );
}
